<app-header></app-header>
<div class="home-wrapper">
    <router-outlet></router-outlet>
</div>
